import React from 'react';
import { Link as LinkRR, useLocation } from 'react-router-dom';
import LayoutType from 'src/shared/utils/layout_type';
import Menu from './Menu';
import MenuMobile from './MenuMobile';
import MenuAccount from './MenuAccount';
import Logo from 'images/logo.svg';
import EmsAdminLogo from 'src/shared/icons/EmsAdminLogo';

import { useGetCurrentUserQuery } from 'src/services/rtk_api/user/sessionApi';

import {
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarMenuToggle,
  Button
} from "@heroui/react";

import classNames from "classnames";
import { Bold } from 'lucide-react';

const Header = ({layoutType}) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const { data: currentUser, refetch, isLoading, error } = useGetCurrentUserQuery(undefined, {
    refetchOnMountOrArgChange: true
  });

  const reloadFrontLink = layoutType !== LayoutType.FRONT_SITE;
  const current_location = useLocation();

  const isHomeVariant = layoutType === LayoutType.FRONT_SITE &&
    ["/", "/login", "/signup"].includes(current_location.pathname);

  const mainLayoutHeader = classNames("main-layout-header", {
    "home-page-header": isHomeVariant,
    "front-site-header": !isHomeVariant
  });

  const klassContainer = classNames({
    'container': ![LayoutType.BOM_QUOTE, LayoutType.BOM_COMPARE].includes(layoutType),
  })

  return (
    <div className={mainLayoutHeader}>
      <div className={klassContainer}>
        <Navbar
          maxWidth="full"
          onMenuOpenChange={setIsMenuOpen}
          className="backdrop-filter-none bg-transparent py-3.5"
          classNames={{
            wrapper: "",
          }}
        >
          <NavbarContent>
            <NavbarMenuToggle
              aria-label={isMenuOpen ? "Close menu" : "Open menu"}
              className="sm:hidden"
            />
            <NavbarBrand>
              <LinkRR to="/" reloadDocument={reloadFrontLink}>
                <EmsAdminLogo 
                  width={217.92}
                  height={27}
                  strokeWidth={0}
                  color={"#ffffff"}
                  fill={"#ffffff"}
                  />
              </LinkRR>
            </NavbarBrand>
          </NavbarContent>


          <NavbarContent justify="end" className="grow-0 gap-7">
            <Menu layoutType={layoutType} />
            { !isLoading && currentUser && !error && process.env.CHARGE_CREDITS_ON_QUOTE === 'true' && process.env.REACT_APP_SIGNUP_ENABLED === 'true' && (
              <div key="credits" className="hidden md:flex px-2 py-1.5 flex flex-row gap-3 cursor-default flex-shrink-0" style={{ alignItems: 'center' }}>
                <p className="text-[#FFE850] text-[16px] font-semibold">{currentUser.team_credits || currentUser.credits} Credits</p>
                <Button style={{ backgroundColor: '#FFE850', color: '#283546', fontWeight: 700, fontStyle: Bold }} as={LinkRR} to="/pricing" href="/pricing" className="button-buy rounded" reloadDocument={reloadFrontLink}>Buy Credits</Button>
              </div>
            )}
            {/* Aquí ocultamos el Login en móvil, y lo enseñamos en ≥sm */}
            <div className="hidden sm:flex">
              <MenuAccount layoutType={layoutType} />
            </div>
          </NavbarContent>
          <MenuMobile layoutType={layoutType} />
        </Navbar>
      </div>
    </div>
  )
}

export default Header;